import type { Contact, Lead } from '../../../types';

/**
 * Normalisiert die POST-/api/leads-Antwort zu einem `Lead` (für Liste).
 * `primary_offering_id` bleibt erhalten: der Server legt mit dem Projekt das erste Angebot an,
 * der Schnellstart „Neues Angebot“ öffnet danach direkt dessen Editor.
 */
export function leadFromCreateApiResponse(
  data: Record<string, unknown>,
): Lead & { primary_offering_id: string | null } {
  const rawId = data.id;
  const parsedId = Number(rawId);
  const id: Lead['id'] =
    typeof rawId === 'number'
      ? rawId
      : Number.isFinite(parsedId) && String(rawId ?? '').trim() !== ''
        ? parsedId
        : String(rawId ?? '');
  const displayId =
    data.display_id != null
      ? String(data.display_id)
      : typeof id === 'number'
        ? `ANF-${String(id).padStart(3, '0')}`
        : `ANF-${String(id).slice(0, 8)}`;
  const site = data.site_address;
  const primaryOfferingId =
    data.primary_offering_id != null && String(data.primary_offering_id).trim()
      ? String(data.primary_offering_id).trim()
      : null;
  return {
    id,
    display_id: displayId,
    name: String(data.name ?? ''),
    email: String(data.email ?? ''),
    phone: String(data.phone ?? ''),
    address: String(data.address ?? ''),
    site_address: site != null && String(site).trim() ? String(site) : null,
    category: data.category != null && String(data.category).trim() ? String(data.category) : null,
    category_key:
      data.category_key != null && String(data.category_key).trim()
        ? String(data.category_key)
        : null,
    category_color:
      data.category_color != null && String(data.category_color).trim()
        ? String(data.category_color)
        : null,
    lead_title: String(data.lead_title ?? data.heating_type ?? ''),
    status: String(data.status ?? 'Neu'),
    notes: String(data.notes ?? ''),
    ai_description: String(data.ai_description ?? ''),
    created_at: String(data.created_at ?? new Date().toISOString()),
    contact_id:
      data.contact_id != null
        ? Number.isFinite(Number(data.contact_id))
          ? Number(data.contact_id)
          : String(data.contact_id)
        : undefined,
    contact: (data.contact as Contact | null) ?? null,
    primary_offering_id: primaryOfferingId,
  };
}
